export default __webpack_public_path__ + "static/media/Communion-Cake.29fc7348.jpg";